import axios from "axios";
import { urlDashboardInterna } from "../../../../../constants/endpoints";

function formatarData(periodo, ano) {
    const hoje = new Date();
    const anoAtual = hoje.getFullYear();

    if(periodo == null){
     return {
        data_inicio: null,
        data_fim: null,
    };
    }

    const dataFim =
        Number(ano) === anoAtual
            ? new Date(Date.UTC(anoAtual, hoje.getMonth(), hoje.getDate()))
            : new Date(Date.UTC(Number(ano), 11, 31));

    const dataInicio = new Date(dataFim);
    dataInicio.setUTCDate(dataInicio.getUTCDate() - periodo);

    const formatar = (d) => d.toISOString().split("T")[0];

    return {
        data_inicio: formatar(dataInicio),
        data_fim: formatar(dataFim),
    };
}

export async function fetchDadosDashboard(companyId, periodo, ano) {
    const { data_inicio, data_fim } = formatarData(periodo, ano);

    const res = await axios.post(urlDashboardInterna, {
        companies: [companyId],
        data_inicio,
        data_fim,
        ano: Number(ano),
    });

    return res?.data;
}

export async function getDadosSempher() {
    const res = await axios.post(urlDashboardInterna);
    return res?.data
}